



































































































































































































































































































































































































































































































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  EighthUnitData, EighthComposeData, emptyEighthUnit,
  getInfo, postData, putData
} from '@/api/eighthHeritage/eighthHeritage'
import { UnitAreaData } from '@/api/heritageUnit/unitBase'
import { validateFloat, validateInt, validateIntKey, validateLngLat, showVaildMsg } from '@/configs/validate'
import {
  getLookupByType, getCitysByUser, DDLItem, DefDDLItem, getHeritageLevel,
  getHeritageClassify, getHeritageSubClassify, getHeritageBatch, getAreaType
} from '@/api/common/select'
import { enLookupType, enFirstType, enUnitLevel } from '@/configs/enums'
import {
  mergeDegrees, splitDegrees, getDDLItem, getDDLName,
  getSubDDL, splitToIntList
} from '@/configs/functions'
import EighthUnitComposeList from '@/components/eighthHeritage/form/composeList.vue'
import UnitFileList from '@/components/heritageUnit/form/fileList.vue'
import UnitFileForm from '@/components/heritageUnit/form/unitFile.vue'
import UnitFileDetail from '@/components/heritageUnit/view/fileDetail.vue'
import DynamicFiles from '@/components/upload/dynamicFiles.vue'
import PageForm from '@/components/pageLayout/form.vue'

const validateDegree = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (rule.tag === 'Lng' && value > 180) {
    callback(new Error('经度不能大于180度'))
  }
  if (rule.tag === 'Lat' && value > 90) {
    callback(new Error('纬度不能大于90度'))
  }
  callback()
}
const validateMinuteSecond = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (value >= 60) {
    callback(new Error('不能大于60'))
  }
  callback()
}
const getFormRules = (id: number, form: { [key: string]: string }) => {
  return {
    LevelId: [
      { required: true, validator: validateIntKey('请选择单位级别'), trigger: 'change' }
    ],
    HeritageCode: [
      { required: true, message: '请输入单位编号', trigger: 'blur' }
    ],
    HeritageName: [
      { required: true, message: '请输入单位名称', trigger: 'blur' }
    ],
    AreaType: [
      { validator: validateIntKey('请选择区域类型'), trigger: 'change' }
    ],
    PublishClassifyId: [
      { required: true, validator: validateIntKey('请选择单位分类'), trigger: 'change' }
    ],
    SubClassifyOther: [
      { required: true, validator: '请输入其他分类', formInfo: form, trigger: 'blur' }
    ],
    SubClassifyId: [
      { required: true, validator: validateIntKey('请选择单位子分类'), trigger: 'change' }
    ],
    StatisticAgeId: [
      { required: true, validator: validateIntKey('请选择统计年代'), trigger: 'change' }
    ],
    PublishAge: [
      { required: true, message: '请输入公布年代', trigger: 'blur' }
    ],
    BatchId: [
      { required: true, validator: validateIntKey('请选择批次'), trigger: 'change' }
    ],
    ApplyUnitName: [
      { required: true, message: '请输入申报单位', trigger: 'blur' }
    ],
    ApplyDate: [{ required: true, message: '请输入申报日期', trigger: 'blur' }],
    FloorArea: [{ type: 'number', message: '必须为数字', trigger: 'blur' }],
    BuiltArea: [{ type: 'number', message: '必须为数字', trigger: 'blur' }],
    PublishAddress: [{ required: true, message: '请输入公布地址', trigger: 'blur' }],
    DetailAddress: [{ required: true, message: '请输入现地址', trigger: 'blur' }],
    StateSummary: [{ required: true, message: '请输入简介', trigger: 'blur' }],
    Description: [{ required: true, message: '请输入文物描述', trigger: 'blur' }],
    CityId: [
      {
        required: true, message: '请选择城市', trigger: 'change',
        validator: validateAreaType, formInfo: form, tag: 'CityId'
      }
    ],
    CountyId: [
      {
        required: true, message: '请选择县区', trigger: 'change',
        validator: validateAreaType, formInfo: form, tag: 'CountyId'
      }
    ],
    LngDegree: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateDegree, tag: 'Lng', trigger: 'blur' }
    ],
    LngMinute: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LngSecond: [
      { validator: validateFloat, message: '请输入数字', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LatDegree: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateDegree, tag: 'Lat', trigger: 'blur' }
    ],
    LatMinute: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LatSecond: [
      { validator: validateFloat, message: '请输入数字', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    SeaHeight: [
      { required: true, type: 'number', message: '必须为数字', trigger: 'blur' },
      { validator: validateIntKey('请输入海拔高度'), trigger: 'blur' }
    ],
    InformantName: [
      { required: true, message: '请输入填报人姓名', trigger: 'blur' }
    ],
    InformantUnit: [
      { required: true, message: '请输入填报人单位', trigger: 'blur' }
    ],
    InformantTel: [
      { required: true, message: '请输入填报人联系电话', trigger: 'blur' }
    ],
    InformantEmail: [
      { required: true, message: '请输入填报人电子邮箱', trigger: 'blur' },
      { type: 'email', message: '电子邮箱格式不正确', trigger: 'blur' }
    ]
  }
}
const validateAreaType = (
  rule: any,
  value: any,
  callback: (error?: Error) => void
) => {
  const areaType = rule.formInfo.AreaType
  if (areaType > 0) {
    if (areaType === 1) {
      if (value === 0) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
    } else if (areaType === 2 || areaType === 3) {
      if (value === 0 && rule.tag === 'CityId') {
        callback(new Error(rule.message))
      } else {
        callback()
      }
    } else if (areaType === 4) {
      if (rule.formInfo.AreaList.length < 2) {
        callback(new Error('多区域至少选择两个区县'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  } else {
    callback(new Error('请选择区域类型'))
  }
}

@Component({
  components: {
    PageForm, EighthUnitComposeList,
    DynamicFiles, UnitFileList, UnitFileForm, UnitFileDetail
  }
})
export default class EighthUnitForm extends Vue {
  public expandNames: string[] = [
    'basic'
    // 'compose', 'position', 'owner', 'other', 'draws', 'pics', 'info'
  ]
  public name = 'EighthUnitForm'
  public textareaSize: any = { minRows: 3, maxRows: 6 }
  public loading = false
  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)

  public form: EighthUnitData = Object.assign({}, emptyEighthUnit)
  public levelList: DDLItem[] = []
  public propertyList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public subClassifyList: DDLItem[] = [this.defItem]
  public areaList: DDLItem[] = []
  public ageList: DDLItem[] = []
  public batchList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]

  // 单位分类中的其他
  public classifyOtherId: number = 0
  public showSubClassifyOther: boolean = false
  // #endregion
  public rules: any = getFormRules(0, this.form)
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    composeCtrl: EighthUnitComposeList
    picCtrl: UnitFileList
    drawCtrl: UnitFileList
    dynamicFilesCtrl: DynamicFiles
  }
  public get backUrl(): string {
    return this.isCountryUnit ? '/CountryUnitApply' : '/ProvinceUnitApply'
  }
  public isCountryUnit: boolean = true
  public created() {
    //通过路由判断是国保还是省保
    this.isCountryUnit = this.$route.path.includes('/CountryUnitApply')
    this.fetchSource()
  }
  public mounted() {
    this.fetchData()
  }
  public setCtrlsData() {
    const f = this.form
    this.$refs.composeCtrl.setData(f.ComposeList)
    this.$refs.picCtrl.setData(f.Pictures)
    this.$refs.drawCtrl.setData(f.Drawings)
    if (
      this.$refs.dynamicFilesCtrl &&
      f.DynamicAttachs &&
      f.DynamicAttachs.length > 0
    ) {
      this.$refs.dynamicFilesCtrl.setData(f.DynamicAttachs)
    }
  }
  public getCtrlsData() {
    let f = this.form
    f.ComposeList = this.$refs.composeCtrl.getData()
    f.Pictures = this.$refs.picCtrl.getData()
    f.Drawings = this.$refs.drawCtrl.getData()
    if (this.$refs.dynamicFilesCtrl) {
      f.DynamicAttachs = this.$refs.dynamicFilesCtrl.getData()
    }
  }
  public ctrlsValided() {
    if (this.$refs.dynamicFilesCtrl) {
      return this.$refs.dynamicFilesCtrl.isValid()
    }
    return true
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
  public fetchSource() {
    getLookupByType(enLookupType.EightUnitLevel, this.firstType).then(
      (response: { data: any }) => {
        this.levelList = response.data
      }
    )
    getHeritageClassify(this.firstType).then((response: { data: any }) => {
      this.classifyList = response.data
      const otherIndex = response.data.findIndex(
        (v: DDLItem) => v.ExInfo.Flag2 == true
      )
      if (otherIndex >= 0) {
        this.classifyOtherId = response.data[otherIndex].Key
      }
    })
    getLookupByType(enLookupType.HeritageAge, this.firstType).then(
      (response: { data: any }) => {
        this.ageList = response.data
      }
    )
    getHeritageBatch(this.firstType).then((response: { data: any }) => {
      this.batchList = response.data
    })
    getCitysByUser(this.firstType).then((response: { data: any }) => {
      this.cityList = response.data
    })
    getAreaType(enFirstType.None).then((response: { data: any }) => {
      this.areaList = response.data
    })
  }
  public fetchData() {
    this.loading = true
    const id = +this.$router.currentRoute.params.id || 0
    getInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        let f = this.form
        if (f.CityId > 0) {
          this.loadCounty(0)
        }
        if (f.PublishClassifyId > 0) {
          this.classifyChange(0)
        }
        this.$nextTick(() => {
          this.setCtrlsData()
        })
        const lng = splitDegrees(f.Longitude)
        f.LngDegree = lng.d
        f.LngMinute = lng.m
        f.LngSecond = lng.s
        const lat = splitDegrees(f.Latitude)
        f.LatDegree = lat.d
        f.LatMinute = lat.m
        f.LatSecond = lat.s

        this.rules = getFormRules(f.Id, f)
        if (f.Id == 0) {
          this.$nextTick(() => {
            this.defSetting()
            this.$refs.formCtrl.clearValidate()
          })
        }
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public defSetting() {
    //单位级别 对应编码
    const category = this.isCountryUnit
      ? enUnitLevel.Country
      : enUnitLevel.Province
    this.form.Category = category
    const batch: any = this.batchList.find(e => e.ExInfo.Code === '8')
    if (batch !== null) {
      this.form.BatchId = batch.Key
      this.form.BatchName = batch.Val
    }
  }
  public onCancel() {
    this.$router.back()
    // this.$router.push({ path: this.backUrl }).catch((data: any) => {
    //   console.log(this.$route.path, data)
    // })
  }
  public onSubmit() {
    if (this.$refs.formCtrl.validate()) {
      this.submitData()
    }
  }
  public submitData() {
    const ctrlValid = this.ctrlsValided()
    if (ctrlValid) {
      this.saveData(false)
    }
  }
  public onTemp() {
    let msg = this.$refs.formCtrl.validateField('HeritageName')
    if (msg == '') {
      msg = this.$refs.formCtrl.validateField('AreaType')
      if (msg == '') {
        msg = this.$refs.formCtrl.validateField('CityId')
        if (msg == '') {
          msg = this.$refs.formCtrl.validateField('CountyId')
        }
      }
    }
    if (msg == '') {
      this.$refs.formCtrl.clearValidate()
      this.saveData(true)
    } else {
      this.$message({
        message: msg, type: 'warning'
      })
    }
  }
  public saveData(isDraft: boolean) {
    this.getCtrlsData()
    let f = Object.assign({}, this.form)
    const lng = mergeDegrees(f.LngDegree, f.LngMinute, f.LngSecond)
    const lat = mergeDegrees(f.LatDegree, f.LatMinute, f.LatSecond)
    if (!isDraft) {
      if (lng == 0 || lat == 0) {
        this.$message({
          message: `请输入经纬度`,
          type: 'warning'
        })
        return false
      }
    }
    f.Longitude = lng
    f.Latitude = lat
    f.IsDraft = isDraft
    const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
    promist.then(
      (response: { data: any }) => {
        const data = response.data
        const msg = f.Id > 0 ? '保存' : '创建'
        if (data && !data.IsError) {
          this.$message({
            message: `${msg}成功`,
            type: 'success'
          })
          this.$router.back()
          // this.$router.push({ path: this.backUrl })
        } else {
          this.$message({
            message: `${data.Message}`,
            type: 'warning'
          })
          console.log('提交失败', data)
        }
        this.$refs.formCtrl.clearValidate()
      },
      (data: any) => {
        console.log(data)
      }
    )
  }
  public classifyChange(reset: number) {
    const f = this.form
    if (reset === 1) {
      f.SubClassifyId = 0
      f.SubClassifyOther = ''
    }
    this.subClassifyList = []
    if (f.PublishClassifyId > 0) {
      if (f.PublishClassifyId === this.classifyOtherId) {
        this.showSubClassifyOther = true
      } else {
        this.showSubClassifyOther = false
        getHeritageSubClassify(f.PublishClassifyId, this.firstType).then(
          (response: { data: any }) => {
            this.subClassifyList = response.data
            if (
              f.SubClassifyId > 0 &&
              this.subClassifyList.findIndex(v => v.Key == f.SubClassifyId) ==
              -1
            ) {
              f.SubClassifyId = 0
            }
          }
        )
      }
    }
  }
  public getDDLCode(list: DDLItem[], key: number) {
    var item = getDDLItem(list, key)
    if (item.Key > 0) {
      return item.ExInfo.Code
    }
    return ''
  }
  // #region 区域类型模块
  public areaTypeChange(value: number) {
    //如果不是多区域，清空市县列表
    if (this.form.AreaType != 4) {
      this.form.AreaList = []
    }
  }
  public cityChange() {
    this.loadCounty(1)
  }
  public loadCounty(reset: number) {
    if (reset === 1) {
      this.form.CountyId = 0
    }
    this.countyList = [this.defItem]
    if (this.form.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, this.form.CityId)
    }
  }
  public addArea() {
    if (this.form.CityId === 0 || this.form.CountyId === 0) {
      this.$message({
        type: 'warning',
        message: '请选择城市和县区'
      })
      return
    }
    const areaIndex: number = this.form.AreaList.findIndex(
      e => e.CityId === this.form.CityId && e.CountyId === this.form.CountyId
    )
    if (areaIndex >= 0) {
      this.$message({
        type: 'warning',
        message: '已存在此城市和县区'
      })
      return
    } else {
      const countyName = getDDLName(this.countyList, this.form.CountyId)
      if (countyName === '') {
        this.$message({
          type: 'warning',
          message: '请选择正确的县区'
        })
        return
      }
      var area: UnitAreaData = {
        Id: 0,
        UnitId: 0,
        ProvinceId: 0,
        ProvinceCode: '',
        ProvinceName: '',
        CityId: this.form.CityId,
        CityCode: this.getDDLCode(this.cityList, this.form.CityId),
        CityName: getDDLName(this.cityList, this.form.CityId),
        CountyId: this.form.CountyId,
        CountyCode: this.getDDLCode(this.countyList, this.form.CountyId),
        CountyName: countyName
      }
      this.form.AreaList.push(area)
      this.$refs.formCtrl.validateField('CityId')
      this.$refs.formCtrl.validateField('CountyId')
    }
  }
  public delArea(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.AreaList.splice(index, 1)
        if (this.form.AreaList.length < 2) {
          this.$refs.formCtrl.validateField('CityId')
          this.$refs.formCtrl.validateField('CountyId')
        }
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消操作'
        // });
      })
  }
  // #endregion
}
